// CHIN-4641: Removed 7 territories to align with NLIHP routing (4/3/2026)
export const pacificCountryCodes = [
  'AS', // American Samoa
  // 'CC', // Cocos (Keeling) Islands
  'CK', // Cook Islands
  'CX', // Christmas Island
  'FJ', // Fiji
  // 'FM', // Micronesia, Federated States of
  // 'GU', // Guam
  // 'HM', // Heard Island and McDonald Islands
  'KI', // Kiribati
  'MH', // Marshall Islands
  // 'MP', // Northern Mariana Islands
  'NC', // New Caledonia
  'NF', // Norfolk Island
  'NR', // Nauru
  'NU', // Niue
  'PF', // French Polynesia
  'PG', // Papua New Guinea
  'PN', // Pitcairn
  'PW', // Palau
  'SB', // Solomon Islands
  'TK', // Tokelau
  'TO', // Tonga
  // 'TV', // Tuvalu
  // 'UM', // United States Minor Outlying Islands
  'VU', // Vanuatu
  'WF', // Wallis and Futuna
  'WS', // Samoa
]
